import {Component, OnInit} from '@angular/core';
import {doctorItems, items} from './mock';
import {Menu} from './menu';
import {LanguageService, UserService} from '../../../services';
import {CONFIG} from "../../../core/config/config";
import {HelpCrunchService} from "../../../shared/services/help-crunch.service";
import {UserModel} from "../../../shared/models/user.model";

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {

  public cLang = CONFIG.LANGS.LANG_DATA.DEFAULT_LANG;
  public items: Menu[] = items;
  public doctorItems: Menu[] = doctorItems;
  public preferredLanguage: string;

  constructor(
    public LS: LanguageService,
    private UserService: UserService,
    public helpCrunchService: HelpCrunchService,
    public userService: UserService
  ) {
    this.cLang = this.LS.getLang();
    const userType = UserService.getUserType();

    if (userType == CONFIG.COMMON.DOCTOR_USER_TYPE) {
      this.items = this.doctorItems;
    }
  }

  ngOnInit() {
    this.userService.getUser
      .subscribe((user: UserModel) => {
        if (user) {
          this.preferredLanguage = user?.preferredLanguage?.name?.toLocaleLowerCase();
        }
      });
      this.userService.getCurrentUser().subscribe(resp => {
        if(resp.marketingTermsAndConditionsAgreement){
          const existingItemIndex = this.items.findIndex(item => item.id === 4);
          if (existingItemIndex === -1) {
            const newItem = { id: 4, path: 'referral', description: 'invitation-code', icon: 'label' };
            this.items.splice(3, 0, newItem);
          }
        } else {
          // If marketingTermsAndConditionsAgreement is false
          // Remove the element if it exists
          const existingItemIndex = this.items.findIndex(item => item.id === 4);
          if (existingItemIndex !== -1) {
            this.items.splice(existingItemIndex, 1);
          }
        }});
  }

}
